// extracted by mini-css-extract-plugin
export default {"confirmation-modal__text":"confirmationmodal_confirmation-modal__text__tUNEj"};